"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/********************************************* EXPORT *********************************************/
/**
 * Date methods to be implemented by the client.
 *
 * @author Andrew Faulkner & Julien Guerinet
 * @since 2.5.0
 */
var DateInterface = /** @class */ (function () {
    function DateInterface() {
    }
    return DateInterface;
}());
exports.DateInterface = DateInterface;
//# sourceMappingURL=javelin-date-interface.js.map